@if (!noRegister) {
  <mat-card [class.invite-register-card]="isInviteReturnFlow">
    <mat-card-header>
      <h1 mat-card-title>
        @if (isInviteReturnFlow) {
          {{ 'invite_login_welcome_title_tr' | translate }} 🎉
        } @else {
          {{ 'Welcome_Note_tr' | translate }} 🎉
        }
      </h1>
    </mat-card-header>
    <mat-card-content>
      <div class="justify-text" [class.invite-note-text]="isInviteReturnFlow">
        @if (isInviteReturnFlow) {
          {{ 'invite_login_welcome_note_tr' | translate }}
        } @else {
          {{ 'getStarted_Short_Note_tr' | translate }}
        }
      </div>
      @if (isInviteReturnFlow) {
        <a class="invite-login-link" href="https://www.supplycanvas.com/" target="_blank" rel="noopener noreferrer">
          {{ 'invite_login_visit_link_tr' | translate }}
        </a>
      }

      <form-actions>
        @if (!isInviteReturnFlow) {
          <button type="button" [routerLink]="['/get-started']" color="primary" mat-raised-button>
            <mat-icon>schedule</mat-icon>
            {{ 'schedule_meeting_btn_tr' | translate }}
          </button>
        }
        @if (isInviteReturnFlow) {
          <button
            type="button"
            [routerLink]="['/register']"
            [queryParams]="authQueryParams"
            data-test="invite-register-cta"
            color="primary"
            mat-flat-button
          >
            <mat-icon>person_add</mat-icon>
            {{ 'register_tr' | translate }}
          </button>
        } @else {
          <button type="button" [routerLink]="['/register']" [queryParams]="authQueryParams" mat-stroked-button>
            <mat-icon>person_add</mat-icon>
            {{ 'register_tr' | translate }}
          </button>
        }
      </form-actions>
    </mat-card-content>
  </mat-card>
}

@if (!noRegister) {
  <div class="auth-flow-separator">
    {{ 'or_if_you_already_have_an_account_tr' | translate }}
  </div>
}

<mat-card>
  <mat-card-header>
    <h1 mat-card-title>{{ 'Login_tr' | translate }}</h1>
  </mat-card-header>

  <mat-card-content>
    <div class="welcome-text">{{ 'Login_Note_tr' | translate }}</div>

    <h3>{{ 'Sign_In_Options_tr' | translate }}</h3>
    <div class="sso">
      <div class="google-signin">
        <app-google-signin-button />
      </div>
      @if (passkeySupported) {
        <button (click)="loginWithPasskey()" [disabled]="passkeyBusy" data-testid="passkey-login-btn" mat-stroked-button type="button">
          <mat-icon>fingerprint</mat-icon>
          {{ 'passkey_login_btn_tr' | translate }}
        </button>
      }
    </div>

    <form [formGroup]="loginForm">
      <h4 style="margin: 0">{{ 'or_use_your_email_pass_tr' | translate }}</h4>
      <mat-form-field>
        <mat-label>{{ 'Email_tr' | translate }}</mat-label>
        <input autotrim formControlName="email" lowerCase matInput placeholder="Login" autocomplete="username webauthn" />
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'Password_tr' | translate }}</mat-label>
        <input formControlName="password" matInput [type]="showPassword ? 'text' : 'password'" autocomplete="current-password" />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
          (click)="showPassword = !showPassword"
        >
          <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>

      @if (loginError) {
        <div class="error-message">
          {{ loginError }}
        </div>
      }

      <form-actions>
        <button type="button" [queryParams]="authQueryParams" [routerLink]="['/reset']" mat-stroked-button>
          {{ 'reset_Password_tr' | translate }}
        </button>
        <button type="submit" (click)="login()" [disabled]="loginForm.invalid" color="primary" mat-raised-button>
          <mat-icon>exit_to_app</mat-icon>
          {{ 'Login_btn_tr' | translate }}
        </button>
      </form-actions>

      @if (showV2Fallback) {
        <div [class.recaptcha-attention]="recaptchaNeedsAttention">
          <app-recaptcha-v2-fallback (solved)="onV2Solved($event)" (failed)="onV2Failed()" />
        </div>
      }
    </form>
  </mat-card-content>
</mat-card>
